export class OfflineQueuedError extends Error {
  readonly queued = true as const;
  readonly outboxId: string;

  constructor(outboxId: string, message?: string) {
    super(message || 'Saved offline — will sync when the local backend is reachable.');
    this.name = 'OfflineQueuedError';
    this.outboxId = outboxId;
  }
}

export function isOfflineQueuedError(err: unknown): err is OfflineQueuedError {
  return (
    !!err &&
    typeof err === 'object' &&
    ((err as OfflineQueuedError).name === 'OfflineQueuedError' ||
      (err as OfflineQueuedError).queued === true)
  );
}
